exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offers .md-table .md-table-cell.actions-cell[data-v-06c646fc]{width:254px;max-width:254px}.error[data-v-06c646fc]{font-size:22px;margin:100px 0 50px;text-align:center;color:rgba(0,0,0,.87);font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06c646fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Tickets/Offers.vue
// module id = 271
// module chunks = 0